import React, { memo } from "react";

interface ITopArrowIconProps {
    color?: string;
}

const TopArrowIcon = ({ color = "#1BA672" }: ITopArrowIconProps) => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <mask id="mask0_550_26547" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
    <rect width="16" height="16" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_550_26547)">
    <path d="M7.11641 6.46971L5.55041 8.03554C5.3843 8.20176 5.17852 8.28487 4.93307 8.28487C4.68763 8.28487 4.48185 8.20176 4.31574 8.03554C4.14952 7.86932 4.06641 7.66354 4.06641 7.41821C4.06641 7.17276 4.14952 6.96693 4.31574 6.8007L7.37291 3.74354C7.55024 3.56621 7.75918 3.47754 7.99974 3.47754C8.2403 3.47754 8.44924 3.56621 8.62657 3.74354L11.6837 6.8007C11.85 6.96693 11.9331 7.17276 11.9331 7.41821C11.9331 7.66354 11.85 7.86932 11.6837 8.03554C11.5176 8.20176 11.3119 8.28487 11.0664 8.28487C10.821 8.28487 10.6152 8.20176 10.4491 8.03554L8.88307 6.46971V11.4182C8.88307 11.6635 8.79718 11.8721 8.62541 12.0439C8.45374 12.2157 8.24518 12.3015 7.99974 12.3015C7.7543 12.3015 7.54574 12.2157 7.37407 12.0439C7.2023 11.8721 7.11641 11.6635 7.11641 11.4182V6.46971Z" fill={color}/>
  </g>
</svg>
);
export default memo(TopArrowIcon);